import React from 'react';
import {
  useTheme,
  useMediaQuery,
  Typography,
  FormControlLabel,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
} from '@mui/material';
import { AppPaper } from '../../layout/appPaper';
import { ViewMode } from '../../models/preferences';
import { ColorPalette } from '../../styles/constants';

const makeStyles = () => ({
  radioLabel: {
    '& .MuiFormControlLabel-label': {
      color: ColorPalette.RAISIN_BLACK,
    },
  },
});

interface Props {
  preference: string;
  onChange: (value: string) => void;
}

export function ViewModeSetting({
  preference,
  onChange,
}: Props): JSX.Element {
  const theme = useTheme();
  const style = makeStyles();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppPaper isMobile={isMobile} sx={{ height: '100%' }}>
      <Typography sx={{ mt: 3, mb: 2 }} variant="h4">
        Activity view
      </Typography>

      <FormControl sx={{ mt: 2 }}>
        <FormLabel
          id="preference-view"
          sx={{ mb: 2, color: ColorPalette.DARK_GRAY }}
          focused={false}
        >
          Set up the default view for your activities
        </FormLabel>
        <RadioGroup
          aria-labelledby="preference-view"
          value={preference}
          onChange={(event) => onChange(event.target.value)}
          name="radio-buttons-group"
        >
          <FormControlLabel
            value={ViewMode.DAY}
            control={<Radio />}
            label="Day view"
            sx={style.radioLabel}
          />
          <FormControlLabel
            value={ViewMode.WORK_WEEK}
            control={<Radio />}
            label="Work week view"
            sx={style.radioLabel}
          />
          <FormControlLabel
            value={ViewMode.WEEK}
            control={<Radio />}
            label="Week view"
            sx={style.radioLabel}
          />
          <FormControlLabel
            value={ViewMode.MONTH}
            control={<Radio />}
            label="Month view"
            sx={style.radioLabel}
          />

          <FormControlLabel
            value={ViewMode.OLD_VIEW}
            control={<Radio />}
            label="List view"
            sx={style.radioLabel}
          />
        </RadioGroup>
      </FormControl>
    </AppPaper>
  );
}
